import { ArrowRightIcon } from "@chakra-ui/icons";
import { Button } from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { Link, LinkProps } from "react-router-dom";

type LinkButtonProps = Omit<
  LinkProps,
  keyof React.AnchorHTMLAttributes<HTMLAnchorElement>
>;

export function LinkButton({
  children,
  to,
  ...linkProps
}: PropsWithChildren<LinkButtonProps>) {
  return (
    <Button
      as={Link}
      iconSpacing={1}
      rightIcon={<ArrowRightIcon h={3} verticalAlign="baseline" />}
      to={to}
      variant="link"
      {...linkProps}
    >
      {children}
    </Button>
  );
}
